import { exportsModule } from '@cian/mf-registry/browser';
import { createMicrofrontendUI } from '../createMicrofrontendUI';
import { createApplicationState } from '../applicationState';
import { createApplicationContext } from '../applicationContext';
import { RUNTIME_NAME } from 'shared/constants/constants';
import { buildAPIRuntime } from './api';

export function runApp() {
  const context = createApplicationContext();
  const store = createApplicationState(context);
  const customElementConstructor = createMicrofrontendUI(context, store);

  exportsModule({
    ui: {
      [RUNTIME_NAME]: customElementConstructor,
    },
    api: () => buildAPIRuntime(store),
  });
}
